import { Platform } from 'react-native';

type PropsWithMaxFontSizeMultiplier = {
  maxFontSizeMultiplier?: unknown;
};

export function omitMaxFontSizeMultiplierOnWeb<T extends PropsWithMaxFontSizeMultiplier>(
  props: T
): T {
  if (Platform.OS !== 'web' || !('maxFontSizeMultiplier' in props)) {
    return props;
  }

  const {
    maxFontSizeMultiplier: _maxFontSizeMultiplier,
    ...propsWithoutMaxFontSizeMultiplier
  } = props;

  return propsWithoutMaxFontSizeMultiplier as T;
}

export function omitMaxFontSizeMultiplierFromTextVariantsOnWeb<T extends Record<string, object>>(
  variants: T
): T {
  if (Platform.OS !== 'web') {
    return variants;
  }

  return Object.keys(variants).reduce((acc, variant) => {
    acc[variant as keyof T] = omitMaxFontSizeMultiplierOnWeb(variants[variant]) as T[keyof T];
    return acc;
  }, {} as T);
}
